
RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_POST_TAGS_TO_SHOW_IN_GRID = 3;

    // PARAMS:
    // - PostTagsById
    // - Post (backbone model form)
    // - Parent view's dashboardModel
    // - postTagsClickable
    // - showActionBtns
    //
    // NOTES:
    // - Displays the post tags passed into it.
    // - Rerenders whenever a post tag has been added / removed
    views.PostTagPills = Marionette.LayoutView.mixin({
        template: '#postTagPillsViewTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            removePostBtn: '.remove-post-tag-btn',
            popovers: '[data-toggle="popover"]'
        },

        events: {
            'click @ui.removePostBtn': 'onRemovePostTagClick'
        },

        regions: {
            postTagAdder: '.add-post-tag-container'
        },

        initialize: function (options) {
            const me = this;

            me.postTagsById = options.postTagsById;
            me.post = options.post;
            me.parentDashboardModel = options.parentDashboardModel;
            me.postTagsClickable = options.postTagsClickable;
            me.showActionBtns = options.showActionBtns || false;
        },

        getAttributeFromPost: function (attr) {
            const me = this;

            if (me.post.get) {
                return me.post.get(attr);
            }
            return me.post[attr];
        },

        onRemovePostTagClick: function (e) { // parentView, target, postTagsById, post) {
            const me = this;

            const source = me.getAttributeFromPost('source');
            const channel = RivalIQ.enums.sourceDetails[source].channel;
            const posts = [{
                channel: channel,
                postNativeIds: [me.getAttributeFromPost('native_id')]
            }];

            const postTagId = $(e.target).parents('.post-tag-pill').data('post-tag-id');

            // NOTE: being optimistic here and updating the UI before the changes were saved to the server;
            // It's possible the server fails, which will leave the UI with the wrong tags applied, but the
            // only error cases we should get are server outages/network issues.
            me.post.attributes.post_tag_ids = _.without(me.post.attributes.post_tag_ids, postTagId);
            RivalIQ.postTags.data.PostTags.trigger('postTag:unapplied', me.postTagsById[postTagId], me.post);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.AppliedPostTags, {
                queryModeEnabled: false,
                numPosts: 1,
                numTagsToAdd: 0,
                numTagsToRemove: 1,
                source: 'inlinePostTagRemove'
            });

            RivalIQ.postTags.data.PostTags.updateAssociations(undefined, [postTagId], posts)
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                });
        },

        serializeData: function () {
            const me = this;

            const postTagIds = me.getAttributeFromPost('post_tag_ids') || [];
            let postTags = RivalIQ.postTags.utils.getPostTags(postTagIds, me.postTagsById);
            _.each(postTags, function (postTag) {
                postTag.clickable = me.postTagsClickable;
            });

            if (postTags.length - 1 > MAX_POST_TAGS_TO_SHOW_IN_GRID) {
                const addlPostTagsCount = postTags.length - MAX_POST_TAGS_TO_SHOW_IN_GRID;

                const elidedPostTags = _.takeRight(postTags, addlPostTagsCount);
                postTags = _.take(postTags, MAX_POST_TAGS_TO_SHOW_IN_GRID);

                const elidedPostTagsDesc = _.map(elidedPostTags, function (postTag) {
                    return `<li>${postTag.postTagHtml}</li>`;
                });

                postTags.push({
                    hideDeleteBtn: true,
                    postTagHtml: `+${addlPostTagsCount} ${RivalIQ.formatter.numericLabel('other', 'others', addlPostTagsCount)}`,
                    popoverHtml: `<ul class="list-unstyled no-margins">${elidedPostTagsDesc.join('')}</ul>`,
                    clickable: false
                });
            }

            return {
                postTags: postTags,
                showActionBtns: me.showActionBtns
            };
        },

        onRender: function () {
            const me = this;

            me.ui.popovers.popover({
                html: true
            });

            if (me.showActionBtns) {
                me.postTagAdder.show(new RivalIQ.apps.SocialPosts.views.PostTagsAdder({
                    postTagsById: me.postTagsById,
                    post: me.post,
                    parentView: me,
                    parentDashboardModel: me.parentDashboardModel
                }));
            }
        }
    });

    views.PostTagsAdder = Marionette.ItemView.extend({
        template: '#postTagAdderTemplate',

        ui: {
            addPostTagBtn: '.add-post-tag-btn'
        },

        events: {
            'click @ui.addPostTagBtn': 'onAddPostTagClick'
        },

        initialize: function (options) {
            const me = this;

            me.parentView = options.parentView;
        },

        onAddPostTagClick: function (e) {
            const me = this;

            e.stopPropagation();

            const target = me.$(e.target);
            const postTagsById = me.options.postTagsById;
            const post = me.options.post;
            const parentView = me.parentView;

            if (parentView._postTagAdderOpen) {
                if (parentView.inlinePostTagsAdder) {
                    parentView.inlinePostTagsAdder.destroy();
                }

                return;
            }

            // We need to stick this on the body as grid items have hidden overflows, and this menu will extend outside of the grid item.
            const btn = (target.hasClass('add-post-tag-btn') ? target : target.parents('.add-post-tag-btn'))[0];
            const dropdownTarget = $('<div class="inline-post-tags-adder" />');
            const boundingRect = btn.getBoundingClientRect();
            dropdownTarget.css('left', boundingRect.x + window.scrollX);
            dropdownTarget.css('top', boundingRect.y + boundingRect.height + window.scrollY);
            $('body').append(dropdownTarget);

            parentView.inlinePostTagsAdder = new RivalIQ.apps.SocialPosts.views.InlinePostTagsAdder({
                el: dropdownTarget,
                postTagsById: postTagsById,
                post: post,
                dashboardModel: me.getOption('parentDashboardModel')
            });
            parentView.inlinePostTagsAdder.render();

            const btnParent = $(btn).parent();
            btnParent.addClass('open');
            parentView._postTagAdderOpen = true;

            // if we're an unexpanded grid item, let's keep the details panel visible for as long
            // as the inline adder is open.
            const unexpandedGridItemParent = $(btn).parents('.social-post-grid-item:not(.expanded)');
            unexpandedGridItemParent.addClass('expanded');

            parentView.on('destroy', function () {
                if (parentView.inlinePostTagsAdder) {
                    parentView.inlinePostTagsAdder.destroy();
                }
            });
            parentView.inlinePostTagsAdder.on('destroy', function () {
                parentView._postTagAdderOpen = false;
                delete parentView.inlinePostTagsAdder;
                btnParent.removeClass('open');
                unexpandedGridItemParent.removeClass('expanded');
            });
        }
    });
});
